export const ANALYZE_FRAMEWORK = '/analyze-framework/'
export const COLLABORATE = '/collaborate/'
export const DEMOGRAPHIC_ANALYSIS = '/demographic-analysis/'
export const FRAMEWORK_INFO = '/framework-info/'
export const HOME = '/'
export const INSTRUCTIONS = '/docs/'
export const INSTRUCTIONS_BRUSHING = '/docs/brushing'
export const INSTRUCTIONS_DESCRIP = '/docs/descrip'
export const INSTRUCTIONS_FRAMEWORK = '/framework-info/framework'
export const INSTRUCTIONS_FRAMEWORK_URL = '/framework-info/framework-url'
export const INSTRUCTIONS_INTRO = '/docs/intro'
export const INSTRUCTIONS_MAP = '/docs/map'
export const INSTRUCTIONS_SETTINGS = '/docs/settings'
export const INSTRUCTIONS_USAGE = '/docs/usage'
export const INSTRUCTIONS_USAGE_ANALYZE = '/docs/usage/analyze'
export const INSTRUCTIONS_USAGE_BRUSHING = '/docs/usage/brushing'
export const INSTRUCTIONS_USAGE_FRAMEWORKS = '/docs/usage/frameworks'
export const INSTRUCTIONS_REFERENCES = '/docs/references'
export const MAP = '/map/'
export const REFUGEE_MODEL = '/refugee-model/'
export const SELECT_BOOKMARK = '/select-bookmark/'
export const SELECT_FRAMEWORK = '/select-framework/'
export const SETTINGS = '/settings/'
export const TRANSIMS = '/transims/'
